import { render, staticRenderFns } from "./modBox.vue?vue&type=template&id=c7c10b04&scoped=true&"
import script from "./modBox.vue?vue&type=script&lang=js&"
export * from "./modBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c10b04",
  null
  
)

export default component.exports